import React from 'react';
import styled from 'styled-components';

//import MUI
import { List, ListItem, ListItemText } from '@mui/material';
import Divider from '@mui/material/Divider';

import ArrowForward from 'react-ionicons/lib/IosArrowForward';

import { backendUrl } from '../services';
import { openExamSchedule } from '../services/examService';
import * as theme from '../theme';

const ExamList = props => {
    const { examSchedules } = props;

    const getTypesOfExams = examSchedules => {
        const examTypes = [];

        examSchedules.forEach(exam => {
            if (
                examTypes.find(
                    et => et.examScheduleTypeID === exam.examScheduleType.examScheduleTypeID
                ) === undefined
            ) {
                examTypes.push(exam.examScheduleType);
            }
        });

        return examTypes;
    };

    return (
        <>
            {getTypesOfExams(examSchedules).map((value, index) => {
                return (
                    <>
                        <Subline children={value.name} />
                        <Container>
                            <StyledList>
                                {examSchedules
                                    .filter(
                                        exam =>
                                            exam.examScheduleType.examScheduleTypeID ===
                                            value.examScheduleTypeID
                                    )
                                    .map((o, i) => {
                                        return (
                                            <div>
                                                <StyledListItem
                                                    key={i}
                                                    onClick={() =>
                                                        openExamSchedule(
                                                            `${backendUrl}/api/Exam/GetExamFile/${o.examFile.examFileID}`
                                                        )
                                                    }
                                                >
                                                    <ListItemText primary={o.title} />
                                                    <ArrowForward color={theme.colors.secondary} />
                                                </StyledListItem>
                                                <Line />
                                            </div>
                                        );
                                    })}
                            </StyledList>
                        </Container>
                    </>
                );
            })}
        </>
    );
};

const Subline = styled.h4`
    text-transform: uppercase;
`;

const Container = styled.div`
    background: #fff;
    box-shadow: 0 5px 10px 1px rgba(0, 0, 0, 0.05);
    margin-bottom: 40px;

    @media (min-width: 640px) {
        padding: 20px;
        margin-bottom: 60px;
    }
`;

const StyledList = styled(List)`
    && {
        width: 100%;
        position: relative;
        overflow: auto;

        li,
        ul {
            margin: 0;
        }
    }
`;

const StyledListItem = styled(ListItem as any)`
    cursor: pointer;
    transition: ease all 0.2s;

    ${props =>
        props.active === 'true' &&
        `
    background: ${theme.colors.secondary};
    color: #fff;

    svg {
      fill: #fff;
    }
  `}

    &:hover {
        background: ${theme.colors.secondary};
        color: #fff;

        svg {
            fill: #fff;
        }
    }

`;

const Line = styled(Divider)`
    && {
        margin: 8px 0;

        &:last-child {
            display:none;
          }
    }
`;

export default ExamList;
